import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

import { useInvoiceForm } from '@hooks/useInvoice'

interface InvoiceDetailsProps {
  invoiceFormPayload: ReturnType<typeof useInvoiceForm>,
}

const InvoiceDetails = (props: InvoiceDetailsProps) => {
  const {
    invoiceFormPayload: {
      entityState: {
        title,
      },
      errors,
      handlers,
    },
  } = props

  return (
    <DashboardModule title="Invoice Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.title} label="* Title">
            <input
              name="title"
              value={title}
              type="text"
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default InvoiceDetails
